import Vue from 'vue'
import Vuex from 'vuex'

import companiesStore from "./companiesStore";

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
      companiesStore,
    },
    
    state: {
      
    },
  
    getters: {
  
    },
  
    mutations: {
      
    },
  })